import { CollapsibleCard, Skeleton } from '@teamsnap/snap-ui';
import * as React from 'react';

export function BalanceChangeSkeleton() {
  return (
    <CollapsibleCard.Root open>
      <CollapsibleCard.Header>
        <Skeleton className="sui-w-[200px] sui-pt-2" />
      </CollapsibleCard.Header>
      <CollapsibleCard.Content>
        <div className="sui-ml-2 sui-mt-2">
          <div className="sui-flex sui-flex-col sui-gap-2">
            <Skeleton className="sui-w-[300px]" />
            <Skeleton className="sui-w-[300px]" />
            <div className="sui-w-[400px] sui-border-t sui-border-solid sui-border-gray-90 sui-mb-3">
              <Skeleton className="sui-mt-2 sui-w-[300px] " />
            </div>
          </div>

          <div className="sui-w-full sui-border-t sui-border-solid sui-border-gray-90 sui-mb-3">
            <Skeleton className="sui-mt-2 sui-w-[300px] sui-pt-2" />
          </div>

          <div className="sui-flex sui-gap-2 sui-flex-col">
            <Skeleton className="sui-w-[150px]" />
            <Skeleton className="sui-w-[400px]" />
            <Skeleton className="sui-w-[150px]" />
            <Skeleton className="sui-w-[300px]" />
            <Skeleton className="sui-w-[400px]" />
          </div>
        </div>
      </CollapsibleCard.Content>
    </CollapsibleCard.Root>
  );
}
